//https://stackoverflow.com/questions/71086276/typeerror-u-readfile-is-not-a-function-in-angular
import React from 'react';
import jsPDF from "jspdf"
import autoTable from 'jspdf-autotable'
// import { Link } from 'react-router-dom';
// import './Lucida Calligra Regular-normal';
import { font } from "./Lucida Calligra Regular-normal";
import { fontt } from "./Zapfino-normal";
import { subdir, wwwdir } from "./logo";

const ExportToPdf = ({ datacurse, user }) => {

  const onchange = async () => {

    console.log("62cf8d3194bde2c00225a36f", datacurse)

    const wwwww =
    {
      "_id": "62cf8d3194bde2c00225a36f",
      "title": "Random Text Generator is a Web Application",
      "institute": "Universidad Nacional de San Cristóbal de Huamanga",
      "faculty": "Facultad de ingeniería de minas, geología y civil",
      "scola": "Escuela Profesional de Ciencias Físico-Matemáticas",
      "user": "62cf8d3194bde2c00225a36f",
      "code": "62cf8d3194bde2c00225a36f",
      "description": "Random Text Generator is a web application which provides true random text which you can use in your documents or web designs. How does it work? First we took many books available on project Gutenberg and stored their contents in a database. Then a computer algorithm takes the words we stored earlier and shuffles them into sentences and paragraphs. The algorithm takes care to create text that looks similar to an ordinary book but without any real meaning.",
      "new": "The reason we want our text to be meaningless is that we want the person viewing the resulting random text to focus on the design we are presenting, rather than try to read and understand the text.",
      "user": "George, Charles Edward",
      "Módulos aprobados": "Lista de las materias o temas vistos con su respectiva calificación",
      "Número de registro": "Un código único de folio o libro para verificar la autenticidad en la base de datos de la institución",
      "QR": "Herramienta moderna para validación digital inmediata",
      "type": "DIPLOMADO",
      "signature1": "George, Charles Edward",
      "signature2": "George, Charles Edward",
      "signature3": "George, Charles Edward",
      "updatedAt": "2026-02-17T02:27:57.149Z",
      "createdAt": "2026-02-17T02:27:57.149Z",
      "__v": 0,
      "responce": null,
      "file": "uploads/collection/4e464faa-430e-4b3b-ae50-71a7a0db3a1b.jpg"
    }

    // Por haber cumplido y aprobado satisfactoriamente los requisitos académicos del DIPLOMADO EN [NOMBRE DEL PROGRAMA] Desarrollado del [Fecha inicio] al [Fecha fin], con una intensidad horaria de [Número] horas. Dado en [Ciudad], a los [Día] días del mes de [Mes] de [Año].

    const doc = new jsPDF({ unit: 'cm', orientation: "landscape", format: [32, 21] })

    doc.addFileToVFS('Zapfino.ttf', fontt);
    doc.addFont('Zapfino.ttf', 'Zapfino', 'normal');

    // doc.addFileToVFS('Lucida Calligra Regular-normal.ttf', font);
    // doc.addFont('Lucida Calligra Regular-normal.ttf', 'Lucida Calligra Regular', 'normal');
    // doc.setFont("Lucida Calligra Regular");

    doc.advancedAPI(() => {
      doc.saveGraphicsState();
      // Use DOMMatrix to create a transformation matrix (translate, rotate, scale)
      let { a, b, c, d, e, f } = new DOMMatrix()
        .translate(-5, doc.internal.pageSize.height / 2)
        .rotate(-45);

      doc.setCurrentTransformationMatrix(doc.Matrix(a, b, c, d, e, f));
      // Draw the shape at a relative origin (e.g., 0, 0)
      for (let i = 1; i < 6; i++) {
        // doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'S');
        doc.setLineWidth(5 / i)
        doc.setDrawColor(155, 155, 35 * i)
        // doc.setFillColor(155, 155, 155)
        let offset = 10;
        doc.rect(-3 + i, 1 + i, 36 - (2 * i), 23 - (2 * i), 'S');
        // doc.rect(0, 0, doc.internal.pageSize.width - i, doc.internal.pageSize.height - i, 'S');
      }
      doc.fill();
      doc.restoreGraphicsState();
    })

    doc.setLineWidth(.1)
    doc.setFillColor(255, 255, 255)

    doc.setDrawColor(255, 255, 255)
    doc.roundedRect(.5, .5, doc.internal.pageSize.width - 1, doc.internal.pageSize.height - 1, 1, 1, 'S')
    doc.setDrawColor(255, 35, 0)
    doc.roundedRect(1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2, 1, 1, 'FD')

    const widthh = doc.internal.pageSize.width
    const heightt = doc.internal.pageSize.height

    doc.setFont("Zapfino");
    var ytag = 3;
    doc.setFontSize(21)
    var splittedText = doc.splitTextToSize(wwwww.institute, 2 * widthh / 3)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 2 * widthh / 3, align: 'center' })
    ytag += blockHeight + .1

    doc.setFont('courier', 'normal')
    doc.setFontSize(15)
    var splittedText = doc.splitTextToSize("Otorga el presente", 2 * widthh / 3)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 2 * widthh / 3, align: 'center' })
    ytag += blockHeight + 1

    doc.setFontSize(21)
    var splittedText = doc.splitTextToSize("DIPLOMA A", 2 * widthh / 3)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 2 * widthh / 3, align: 'center' })
    ytag += blockHeight + 1

    doc.setFont("Zapfino");
    doc.setFontSize(15)
    var splittedText = doc.splitTextToSize(user.name, 3 * widthh / 2)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 3 * widthh / 2, align: 'center' })
    ytag += blockHeight + .6

    // doc.setFontSize(29)
    // var splittedText = doc.splitTextToSize(datacurse.title, 3 * widthh / 2)
    // var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    // var blockHeight = splittedText.length * lineHeight
    // doc.text(splittedText, widthh / 2, ytag, { maxWidth: 3 * widthh / 2, align: 'center' })
    // ytag += blockHeight + .5


    doc.setFont('courier', 'normal')

    doc.setFontSize(14)
    doc.text(`Por haber cumplido y aprobado satisfactoriamente los requisitos académicos del DIPLOMADO EN ${datacurse.title}. Desarrollado del ${datacurse.createdAt} al ${datacurse.updatedAt}, con una intensidad horaria de ${datacurse.credito} horas. Dado en Huamanga Ayacucho, a los ${new Date().getDay() + 1} días del mes de ${new Date().getMonth()} de ${new Date().getFullYear()}`, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    var splittedText = doc.splitTextToSize(wwwww.description, 17 * widthh / 19)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    ytag += blockHeight + .1

    // doc.text(wwwww.new, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    // var splittedText = doc.splitTextToSize(wwwww.new, 17 * widthh / 19)
    // var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    // var blockHeight = splittedText.length * lineHeight
    // ytag += blockHeight + .1

    doc.text(datacurse.updatedAt.toString, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    ytag += 1
    doc.text(wwwww.code, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    ytag += 1
    doc.text(wwwww.code, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })


    doc.setFont('courier', 'bold')
    doc.setFontSize(15)
    doc.setTextColor(1, 198, 255);

    doc.text(wwwww.signature1, 1 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(wwwww.signature2, 3 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(wwwww.signature3, 5 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });

    // (interior) agregar imagen(imageData, formato, x, y, ancho, alto, alias, compresión, rotación)
    var imgData = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData, 'jpeg', 1.5, 15.2, 8, 3.1, "", 'NONE', -1)
    var imgData2 = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData2, 'jpeg', 12.5, 15.2, 8, 3.1, "", 'NONE', -1)
    var imgData3 = 'data:image/jpeg;base64,' + wwwdir
    doc.addImage(imgData3, 'png', 22.5, 15.2, 8, 3.5, "", 'NONE', 1)



    /////////////////////////////////////////////////////////////////////////////////
    doc.addPage();
    /////////////////////////////////////////////////////////////////////////////////



    doc.advancedAPI(() => {
      doc.saveGraphicsState();
      // Use DOMMatrix to create a transformation matrix (translate, rotate, scale)
      let { a, b, c, d, e, f } = new DOMMatrix()
        .translate(-5, doc.internal.pageSize.height / 2)
        .rotate(-45);

      doc.setCurrentTransformationMatrix(doc.Matrix(a, b, c, d, e, f));
      // Draw the shape at a relative origin (e.g., 0, 0)
      for (let i = 1; i < 6; i++) {
        // doc.rect(0, 0, doc.internal.pageSize.width, doc.internal.pageSize.height, 'S');
        doc.setLineWidth(5 / i)
        doc.setDrawColor(155, 155, 35 * i)
        // doc.setFillColor(155, 155, 155)
        let offset = 10;
        doc.rect(-3 + i, 1 + i, 36 - (2 * i), 23 - (2 * i), 'S');
        // doc.rect(0, 0, doc.internal.pageSize.width - i, doc.internal.pageSize.height - i, 'S');
      }
      doc.fill();
      doc.restoreGraphicsState();
    })

    doc.setLineWidth(.1)
    doc.setFillColor(255, 255, 255)

    doc.setDrawColor(255, 255, 255)
    doc.roundedRect(.5, .5, doc.internal.pageSize.width - 1, doc.internal.pageSize.height - 1, 1, 1, 'S')
    doc.setDrawColor(255, 35, 0)
    doc.roundedRect(1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2, 1, 1, 'D')

    doc.setFont('courier', 'normal')
    var ytag = 3;
    doc.setFontSize(21)
    var splittedText = doc.splitTextToSize(wwwww.institute, 2 * widthh / 3)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 2 * widthh / 3, align: 'center' })
    ytag += blockHeight + 1

    doc.setFont("Zapfino");
    doc.setFontSize(29)
    var splittedText = doc.splitTextToSize(wwwww.title, 3 * widthh / 2)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    doc.text(splittedText, widthh / 2, ytag, { maxWidth: 3 * widthh / 2, align: 'center' })
    ytag += blockHeight + .5

    doc.setFont('courier', 'normal')

    doc.setFontSize(14)
    doc.text(wwwww.description, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    var splittedText = doc.splitTextToSize(wwwww.description, 17 * widthh / 19)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight
    ytag += blockHeight + .5

    doc.text(wwwww.new, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    var splittedText = doc.splitTextToSize(wwwww.new, 17 * widthh / 19)
    var lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    var blockHeight = splittedText.length * lineHeight

    ytag += blockHeight + .5
    doc.text(wwwww.updatedAt.toString, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    ytag += 1
    doc.text(wwwww.code, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })
    ytag += 1
    doc.text(wwwww.code, widthh / 19, ytag, { maxWidth: 17 * widthh / 19, align: 'justify' })


    doc.setFont('courier', 'bold')
    doc.setFontSize(15)
    doc.setTextColor(1, 198, 255);

    doc.text(wwwww.signature1, 1 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(wwwww.signature2, 3 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });
    doc.text(wwwww.signature3, 5 * widthh / 6, 14.5 * heightt / 16, { maxWidth: 2 * widthh / 6, align: 'center' });

    var body = [
      ['SL.No', 'Product Name', 'Price', 'Model'],
      [1, 'I-phone', 75000, '2021'],
      [2, 'Realme', 25000, '2022'],
      [3, 'Oneplus', 30000, '2021'],
    ]
    // generate auto table with body
    var y = 10;
    doc.setLineWidth(2);
    doc.text(200, y = y + 30, "Product detailed report");
    doc.autoTable({
      body: body,
      startY: 70,
      theme: 'grid',
    })

    // (interior) agregar imagen(imageData, formato, x, y, ancho, alto, alias, compresión, rotación)
    var imgData = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData, 'jpeg', 1.5, 15.2, 8, 3.1, "", 'NONE', -1)
    var imgData2 = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData2, 'jpeg', 12.5, 15.2, 8, 3.1, "", 'NONE', -1)
    var imgData3 = 'data:image/jpeg;base64,' + wwwdir
    doc.addImage(imgData3, 'png', 22.5, 15.2, 8, 3.5, "", 'NONE', 1)





    doc.save('downloaded-pdf-with-image.pdf');

  }

  return (
    <>
      <button onClick={onchange} className='btn btn-primary'>IMPRIMIR DIPLOMA</button>
    </>
  )
}

export default ExportToPdf





